import { _ as a } from "./main29.js";
import { _ as r } from "./main37.js";
var o = a, t = r, p = o(t, "Map"), v = p;
export {
  v as _
};
